import {
    hideAction,
    hidePostcodeInvalidAction,
    showPostcodeInvalidAction,
    submitCatalogConfiguratorForm,
} from '../../_flux/actions/catalog_configurator_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';
import { validatePostcode } from '../../validator/PostcodeAutocompleteValidator';
import { onOpenRegoLookupV2Click, onOpenVehicleConfiguratorV2Click } from '../configurator_buttons/configurator_buttons';
import { showConfirmationLayerAction, showInputLayerAction } from '../../_flux/actions/rego_lookup_actions';
import LastUsedConfiguratorStore from '../../_flux/stores/last_used_configurator_store';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';
import { types } from '../../_constants/product/types';
import { applyFilters } from '../../_flux/helper/apply_filters';


export function onConfiguratorSubmitFactory(tyreType) {
    return () => {
        const { values, postcodeSuggestion, touched, postcodeInvalidMessage } = CatalogConfiguratorStore.getState();
        const { configuratorSource } = LastUsedConfiguratorStore.getState();
        const regoLookupState = RegoLookupStore.getState();

        if (
            values.postcode === '' ||
            (values.postcode && validatePostcode(TYROOLA.globals.store, values.postcode, postcodeSuggestion, touched))
        ) {
            if (postcodeInvalidMessage) {
                hidePostcodeInvalidAction();
            }

            hideAction();
            submitCatalogConfiguratorForm();
            updateFiltersAction({
                [Filters.WIDTH]: values[Filters.WIDTH],
                [Filters.HEIGHT]: values[Filters.HEIGHT],
                [Filters.DIAMETER]: values[Filters.DIAMETER],
                [Filters.SPEED_INDEX]: values[Filters.SPEED_INDEX],
                [Filters.LOAD_INDEX]: values[Filters.LOAD_INDEX],
                [Filters.USAGE]: values[Filters.USAGE],
                [Filters.VEHICLE_TYPE]: values[Filters.VEHICLE_TYPE],
                [Filters.RUN_FLAT]: values[Filters.RUN_FLAT],
                [Filters.BUY_4_PAY_3]: values[Filters.BUY_4_PAY_3],
                [Filters.CLEARANCE]: values[Filters.CLEARANCE],
                [Filters.POSTCODE]: values[Filters.POSTCODE] || '',
            });
            
            if (tyreType === types.TYRE_MOTO) {
                applyFilters(tyreType);
            } else {
                if (configuratorSource === 'vehicle_configurator') {
                    onOpenVehicleConfiguratorV2Click(true);
                } else {
                    if (regoLookupState.values[Filters.VEHICLE_ID]) {
                        showConfirmationLayerAction();
                    } else {
                        showInputLayerAction();
                    }
                    onOpenRegoLookupV2Click(true);
                }
            }
        } else {
            showPostcodeInvalidAction();
        }
    }
}
